function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 12.9,
  height: 14.5,
  x: 0.75,
  y: 0.75,
  stroke: "currentColor",
  strokeWidth: 1.5,
  rx: 1.25
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1.6,
  height: 8,
  x: 3.2,
  y: 5.6,
  fill: "currentColor",
  rx: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 1.6,
  height: 6.4,
  x: 6.4,
  y: 7.2,
  fill: "currentColor",
  rx: 0.8
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 1.6,
  height: 4,
  x: 9.6,
  y: 9.6,
  fill: "currentColor",
  rx: 0.8
});

function SvgAudit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none",
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.5c06406b.svg";
export { ForwardRef as ReactComponent };